import { render } from "./ApproveLiquidation.vue?vue&type=template&id=72f84d8d"
import script from "./ApproveLiquidation.vue?vue&type=script&lang=js"
export * from "./ApproveLiquidation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__